const WagerConfigReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeWagerConfig":
      return action.payload;
    default:
      return state;
  }
};

export default WagerConfigReducers;
